var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Frame',[_c('PageHeader',{attrs:{"title":_vm.title,"hasBack":true,"detailType":"HelpCenterDetail"}}),_c('div',{staticClass:"body-container"},[_c('span',{staticClass:"timeinfo"},[_vm._v(_vm._s(_vm.timeinfo))]),_c('div',{ref:"innerhtml",staticClass:"helpinfo",style:(_vm.height)})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }